import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, getElementCenterPos, LL_H_C, LL_V_L, ModuleFE_MouseInteractivity, ModuleFE_Thunderstorm, mouseInteractivity_PopUp } from '@nu-art/thunderstorm-frontend/index';
import './Component_ReferencableViewer.scss';
import { __stringify } from '@nu-art/ts-common';
import { translateReferencable } from './utils.js';
import { ModuleFE_Referencable } from '../ModuleFE_Referencable.js';
import { ICONS } from '@app/styles';
export class Component_ReferencableViewer extends ComponentSync {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.referencable = nextProps.referencable;
        state.translatedRef = this.getTranslatedReferencable(state.referencable);
        state.className = nextProps.className;
        state.allowMenu = !!nextProps.allowMenu;
        state.showSimplified ??= true;
        return state;
    }
    // ######################## Logic ########################
    getTranslatedReferencable(referencable) {
        if (!referencable)
            return;
        const map = ModuleFE_Referencable.cache.all().reduce((map, ref) => {
            map[ref._id] = ref;
            return map;
        }, {});
        return translateReferencable(referencable, map);
    }
    getMenuActions = () => {
        const menuActions = [];
        //Download ref JSON
        menuActions.push({
            label: 'Export Referencable',
            action: () => {
                ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                const item = this.state.referencable;
                if (!item)
                    return;
                ModuleFE_Thunderstorm.downloadFile({
                    fileName: `Referencable - ${item.label}`,
                    mimeType: 'application/json',
                    content: __stringify(item, true)
                });
            }
        });
        //Download ref + hierarchy JSON
        menuActions.push({
            label: 'Export Referencable Space',
            action: () => {
            }
        });
        //Switch ref parsing method
        menuActions.push({
            label: 'Toggle Parsing Method',
            action: () => {
                ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                this.setState({ showSimplified: !this.state.showSimplified });
            }
        });
        return menuActions;
    };
    openMenu = (e) => {
        const model = {
            id: 'ref-viewer-menu',
            modalPos: { x: -1, y: 1 },
            originPos: getElementCenterPos(e.currentTarget),
            xAxisAnchor: 'left',
            offset: { x: -5, y: 5 },
            content: () => {
                return this.getMenuActions().map((menuAction, index) => _jsx(Button, { variant: 'text', onClick: menuAction.action, children: menuAction.label }, index));
            }
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    // ######################## Render ########################
    render() {
        if (!this.state.referencable)
            return;
        const className = _className('referencable-viewer', this.state.className);
        return _jsxs(LL_V_L, { className: className, children: [this.render_Header(), this.render_Body()] });
    }
    render_Header = () => {
        return _jsxs(LL_H_C, { className: 'referencable-viewer__header', children: [this.state.referencable.label, this.state.allowMenu &&
                    _jsx(ICONS.more.component, { onClick: this.openMenu })] });
    };
    render_Body = () => {
        const toShow = this.state.showSimplified ? this.state.translatedRef : this.state.referencable;
        return _jsx("p", { children: __stringify(toShow, true) });
    };
}
//# sourceMappingURL=Component_ReferencableViewer.js.map